import $ from "jquery";
import {EventEmitter} from "eventemitter3";

export default class Utils extends EventEmitter {

    constructor(opts) {
        super();

        this.timers = {};
    }

    /**
     * Get average colour of any image (by href)
     * PS: using an image element is simpler, but this needs to work for BG images too
     *
     * @param url
     * @param element   | can be a JS object / payload to identify initial image
     * @returns {{r: number, g: number, b: number}}
     */
    getAverageRGB(url, element) {
        //

        var me = this;
        var imgEl = new Image();
        imgEl.onload = function(e) {
            //
            var blockSize = 5, // only visit every 5 pixels
                defaultRGB = {r: 0, g: 0, b: 0}, // for non-supporting envs
                canvas = document.createElement('canvas'),
                context = canvas.getContext && canvas.getContext('2d'),
                data, width, height,
                i = -4,
                length,
                rgb = {r: 0, g: 0, b: 0},
                count = 0;

            if (!context) {
                return defaultRGB;
            }

            height = canvas.height = imgEl.naturalHeight || imgEl.offsetHeight || imgEl.height;
            width = canvas.width = imgEl.naturalWidth || imgEl.offsetWidth || imgEl.width;

            context.drawImage(imgEl, 0, 0);

            try {
                data = context.getImageData(0, 0, width, height);
            } catch (e) {
                /* security error, img on diff domain */
                console.warn('Domains do not match.')
                return defaultRGB;
            }

            length = data.data.length;

            while ((i += blockSize * 4) < length) {
                ++count;
                rgb.r += data.data[i];
                rgb.g += data.data[i + 1];
                rgb.b += data.data[i + 2];
            }

            // ~~ used to floor values
            rgb.r = ~~(rgb.r / count);
            rgb.g = ~~(rgb.g / count);
            rgb.b = ~~(rgb.b / count);

            // var luminance = 0.2126 * rgb.r + 0.7152 * rgb.g + 0.0722 * rgb.b;
            var luminance = 0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b;


            // Async, so we need to bubble an event
            me.emit('utils.averageRGB', {rgb: rgb, luminance: luminance, element: element || {}});
            // uup.
            return rgb;


        };
        imgEl.src = url;


    }


    convertMailto() {
        var regEx = /(\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*)/;

        $("body").filter(function() {
            return $(this).html().match(regEx);
        }).each(function() {
            $(this).html($(this).html().replace(regEx, "<a href=\"mailto:$1\">$1</a>"));
        });
    }


    debounce(callback, ms, uniqueId) {

            if (!uniqueId) {
                uniqueId = "Don't call this twice without a uniqueId";
                return;
            }
            if (this.timers[uniqueId]) {
                clearTimeout(this.timers[uniqueId]);
            }
            this.timers[uniqueId] = setTimeout(callback, ms);

    }

    clamp(n, min,max) {
        return Math.min(Math.max(n, min), max);
    }

    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}
